import React from 'react';

import { SEO, Container, ContactForm } from '@components';

function ContactPage() {
    return (
        <Container>
            <SEO title="Contact Us" />
            <ContactForm
                title="We're excited to learn about your project"
                description={
                    <>
                        Request a free full estimate or ask a simple question. <br />
                        We&apos;re happy to help you with all your home remodeling and construction needs.
                    </>
                }
                showPromotion
            />
        </Container>
    );
}

export default ContactPage;
